/*=========================================================================================
  File Name: moduleMailSendResumeState.js
  Description: Kinds Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  mailSendResumes: [],
  infoDB: {}
}
